import ProjectManager from '../canvas/ProjectManager';
import layerLibrary from '../canvas/LayerLibrary';
import layoutEngine from '../libraries/layoutEngine';
import { hexToRgba } from '../libraries/RectangleLibrary';
import { uuidv4 } from '../utils/uuid';

export default class PolygonToolHandler {
  constructor(engine) {
    this.engine = engine;
    this.points = [];
    this.isDrawing = false;
    this.mouseX = null;
this.mouseY = null;
this._polygonCommitted = false;


  }

  snap(x, y) {
    const s = this.engine.gridSpacing || 20;
    return [Math.round(x / s) * s, Math.round(y / s) * s];
  }

  updateMousePosition(x, y) {
  if (!this.isDrawing) return; // 👈 Ignore if not drawing
  this.mouseX = x;
  this.mouseY = y;
}



  handleMouseDown(e) {
    if (e.button !== 0) return;
  if (e.detail && e.detail > 1) return;
  if (!this.isDrawing) {
    this.isDrawing = true;
    this._polygonCommitted = false;   // ✅ naya polygon start hote hi reset
    this.points = [];                 // ✅ fresh poly (optional but safer)
  }

  const { offsetX, offsetY, scale } = this.engine;
  const canvasX = (e.offsetX - offsetX) / scale;
  const canvasY = (e.offsetY - offsetY) / scale;

  const snappedX = this.engine.snapToGrid(canvasX);
  const snappedY = this.engine.snapToGrid(canvasY);

  this.points.push([snappedX, snappedY]);
  this.engine.draw();
}



 handleDoubleClick(e) {
  console.log("🔥 Double click triggered");

  if (!this.isDrawing || this._polygonCommitted) return;

  const cellName = ProjectManager.getSelectedCell() || ProjectManager.getTopCellName();
  const selectedLayerId = layerLibrary.getSelectedLayerId();
  const selectedLayer = layerLibrary.getLayerById(selectedLayerId);
  console.log("👉 selectedLayerId", selectedLayerId);
  console.log("👉 selectedLayer", selectedLayer);

  // ✅ Route to the correct cell: uploaded takes priority when engine is in uploaded mode
  const uploadedCell = this.engine.useUploadedCells
    ? layoutEngine.getUploadedCell(cellName)
    : null;
  const cell = uploadedCell || layoutEngine.getCellByName(cellName);

  if (!cell || this.points.length < 3 || !selectedLayerId) {
    return;
  }

  const alreadyExists = cell.elements.some(el =>
    el.type === "polygon" &&
    el.points?.length === this.points.length &&
    el.points.every((pt, idx) => pt[0] === this.points[idx][0] && pt[1] === this.points[idx][1])
  );

  if (alreadyExists) {
    console.warn("⚠️ Polygon already exists. Skipping push.");
    this.points = [];
    this.isDrawing = false;
    this.mouseX = null;
    this.mouseY = null;
    this.engine.draw();
    return;
  }

  this._polygonCommitted = true;

  const strokeColor = selectedLayer.color || "black";
  const fillColor = selectedLayer.color
    ? selectedLayer.color.replace("rgb", "rgba").replace(")", ",0.3)")
    : "rgba(0,0,0,0.3)";

  const layerNum = String(selectedLayer.layer_number ?? 1);
  const dtypeNum = String(selectedLayer.datatype_number ?? 0);
  const layerId  = `${layerNum}:${dtypeNum}`;

  cell.elements.push({
    id: uuidv4(),           // ✅ was `uuidv4` (function ref) — now correctly called
    type: 'polygon',
    points: [...this.points],
    stroke: strokeColor,
    fill: fillColor,
    layerId,
    layer: layerNum,
    datatype: dtypeNum,
    layerNumber: layerNum,
    datatypeNumber: dtypeNum,
    layerName: selectedLayer.layer_name || "unknown",
    datatypeName: selectedLayer.datatype_name || "unknown",
    opacity: selectedLayer.pattern?.opacity ?? 1,
  });

  // ✅ Clear everything ONLY if polygon was actually pushed
  this.points = [];
  this.mouseX = null;
  this.mouseY = null;
  this.isDrawing = false;

  this.engine.draw();
}




 drawPreview(ctx) {
  if (!this.isDrawing || this.points.length === 0) return;

  const pts = this.points;
  const first = pts[0];
  const last  = pts[pts.length - 1];

  ctx.save();

  // 1) Polyline: last → cursor (dashed)
  if (this.mouseX != null && this.mouseY != null) {
    ctx.beginPath();
    ctx.setLineDash([4, 2]);
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'yellow';
    ctx.moveTo(last[0], last[1]);
    ctx.lineTo(this.mouseX, this.mouseY);
    ctx.stroke();
  }

  // 2) Closure cue: (second click ke baad) start → cursor (dashed)
  if (pts.length >= 2 && this.mouseX != null && this.mouseY != null) {
    ctx.beginPath();
    ctx.setLineDash([6, 4]);
    ctx.lineWidth = 1;
    ctx.strokeStyle = 'yellow';
    ctx.moveTo(first[0], first[1]);
    ctx.lineTo(this.mouseX, this.mouseY);
    ctx.stroke();
  }

  // 3) Existing placed segments (solid)
  ctx.setLineDash([]);
  ctx.beginPath();
  ctx.moveTo(first[0], first[1]);
  for (let i = 1; i < pts.length; i++) ctx.lineTo(pts[i][0], pts[i][1]);
  ctx.strokeStyle = 'yellow';
  ctx.lineWidth = 1;
  ctx.stroke();

  ctx.restore();
}


// PolygonToolHandler.js
cancel() {
  this.points = [];
  this.isDrawing = false;
  this.mouseX = null;
  this.mouseY = null;
  this._polygonCommitted = false;
  this.engine.draw();
}


}
